import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    bankaccount() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/bankcashacc/allaccount");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    currency() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/currency/cbo");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    potongan() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/payment/potongan");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.post("paymentsuspend",obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    reverse(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.post("paymentsuspend/reverse",obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 
                'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 
                'nomor', 'CustCode','CustName','no_kontrak','no_agreement','namabank', 'reference',
                 'tgldue1', 'tgldue2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/paymentsuspend${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/paymentsuspend/detail/${obj.arpaymsusKey}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/paymentsuspend/${obj.arpaymsusKey}`;
                const { data } = await axios.delete(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    unpostingtrx(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.post("/paymentsuspend/unposting",obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
}